// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_container__25Uy8","title":"switch_title__3rrTx","checkbox_group":"switch_checkbox_group__2UJRq","checkbox_item":"switch_checkbox_item__3PmwP"};